


































import { editFactory } from '@/main/pages';
import { Pracovnik } from '@/modules/administrace/pracovnik';

import { NAME } from './constants';
import { store } from './store/edit';
import { types } from './store/types';

export default editFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				pracovnik: `${this.storeUri}/${types.mutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
});
